import client from '../axios';
import { DELETE_BOARD_TASK, GET_BOARD_TASK_DETAIL, POST_BOARD_TASK, PUT_BOARD_TASK, PUT_BOARD_TASK_FIX, GET_BOARD_BOARDTYPE 
,GET_BOARD_CLASS_CATEGORY,GET_BOARD_CLASS_CATEGORY_3RD,GET_BOARD_CLASS, POST_BOARD_CLASS, GET_BOARD_CLASS_DETAIL, PUT_BOARD_CLASS, DELETE_BOARD_CLASS, POST_DELETE_BOARD_CLASS,
GET_BOARD_READ,
GET_BOARD_TASK_READ_MEMBER
} from './endpoint';

// 업무게시판 등록
export const postBoardTaskAPI = (data) => {
  return client.post(POST_BOARD_TASK, data)
}

// 업무게시판 상세
export const getBoardTaskDetailAPI = (idx, params) => {
  return client.get(GET_BOARD_TASK_DETAIL.replace(':idx', idx), { params })
}

// 업무게시판 수정
export const putBoardTaskAPI = (data) => {
  return client.put(PUT_BOARD_TASK, data)
}

// 업무게시판 삭제
export const deleteBoardTaskAPI = (data) => {
  return client.delete(DELETE_BOARD_TASK, {data})
}

// 업무게시판 상단고정
export const putBoardTaskFixAPI = (data) => {
  return client.put(PUT_BOARD_TASK_FIX, data)
}

// 업무게시판 열람회원 목록
export const getBoardTaskReadMemberAPI = (idx) => {
  return client.get(GET_BOARD_TASK_READ_MEMBER.replace(':idx', idx))
}

// 수업자료용 카테고리
export const getBoardClassCategoryAPI = (params) => {
  const url = GET_BOARD_CLASS_CATEGORY;
  return client.get(url, {params})
}
// 수업자료용 카테고리
export const getBoardClassCategory3rdAPI = (params) => {
  const url = GET_BOARD_CLASS_CATEGORY_3RD;
  return client.get(url, {params})
}
// 수업자료 목록
export const getBoardClassAPI = (params) => {
  const url = GET_BOARD_CLASS;
  return client.get(url, {params})
}

// 수업자료 등록
export const postBoardClassAPI = (data) => {
  const url = POST_BOARD_CLASS;
  return client.post(url, data)
}

// 수업자료 상세
export const getBoardClassDetailAPI = (idx) => {
  const url = GET_BOARD_CLASS_DETAIL;
  return client.get(url.replace(':idx', idx))
}

// 수업자료 수정
export const putBoardClassAPI = (data) => {
  const url = PUT_BOARD_CLASS;
  return client.put(url, data)
}

// 수업자료 삭제
export const deleteBoardClassAPI = (data) => {
  const url = DELETE_BOARD_CLASS;
  return client.delete(url, {data})
}
// 수업자료 삭제 (array)
export const postDeleteBoardClassAPI = (data) => {
  const url = POST_DELETE_BOARD_CLASS;
  return client.post(url, data)
}

//게시판타입
export const getBoardTypeAPI = () => {
  return client.get(GET_BOARD_BOARDTYPE)
}